import type { ArticleCategory } from '../core/types/content'

/**
 * Gegenereerde sfeerbeelden per plek (docs/BEELDEN.md). Eén fotostijl: daglicht, linnen en zand,
 * warme huidtinten, geen tekst in beeld. Het zijn géén foto's van de echte salon of van Sarah:
 * tijdelijk, vervangen door eigen foto's vóór livegang. Een beeld dat in het beheer is gekozen,
 * gaat altijd voor; deze vullen alleen een plek die anders leeg zou zijn.
 */
export const placeholderImages = {
  /** H1 · Home, opening: huidspecialist met producten in de behandelkamer (4:5). */
  homeHero: 'https://cdn.magicpatterns.com/patterns/generated-images/d9ad7e80-ec5b-4241-933a-d199b3130144.jpg',
  /** W1 · Webshop: serum op de vingertop, een product in gebruik (21:9). */
  shopInUse: 'https://cdn.magicpatterns.com/patterns/generated-images/67641fd5-4c99-4ee8-aa9d-1f0d352cd9db.jpg',
  /** P2 · Product: textuur van crème en serum op zand (1:1). */
  productTexture: 'https://cdn.magicpatterns.com/patterns/generated-images/05943adc-8794-434e-bcce-7277493f8d06.jpg',
  /** S/O · Salon + Over + Home "kom langs": de behandelkamer in daglicht (4:5). */
  salonRoom: 'https://cdn.magicpatterns.com/patterns/generated-images/12880a60-c23b-49bb-b836-2609a96a26cb.jpg',
  /** C1 · Contact: de voordeur in daglicht (21:9). */
  contactDoor: 'https://cdn.magicpatterns.com/patterns/generated-images/abeab843-b3fc-4a51-a72d-80107c6c0aa5.jpg',
} as const

/** A1 · Artikel zonder eigen beeld: een rustige textuur (huid, ingrediënt of ritueel, 21:9). */
const articleTextures = {
  skin: 'https://cdn.magicpatterns.com/patterns/generated-images/8bcbf1b4-b9d3-475a-aa75-b830f15f2749.jpg',
  ingredient: 'https://cdn.magicpatterns.com/patterns/generated-images/02bb9398-6df2-4c83-9111-61437076fd2f.jpg',
  ritual: 'https://cdn.magicpatterns.com/patterns/generated-images/ff656fc9-cf09-43cb-a80a-5eb3b5062e1d.jpg',
} as const

const byCategory: Record<ArticleCategory, string> = {
  Producten: articleTextures.ingredient,
  Huidkennis: articleTextures.skin,
  'Energetisch werk': articleTextures.ritual,
}

/**
 * Het terugvalbeeld voor een artikel zonder eigen beeld: vast per categorie, zodat het journal
 * rustig blijft.
 */
export function articleTexture(category: ArticleCategory): string {
  return byCategory[category]
}
